module.exports = __webpack_public_path__ + "static/img/gptModel42.934d15a1.png";